import styled from 'styled-components';

import { colors } from '../../styles';

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  background-color: ${colors.white};
  color: ${colors.black};
`;

export default Table;
